var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16h.02M25 42H12a6 6 0 01-6-6V12a6 6 0 016-6h24a6 6 0 016 6v13",
    stroke: "#94A3B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32l10-10c1.856-1.786 4.144-1.786 6 0l6 6 2-2c1.232-1.186 2.656-1.584 4.016-1.196M34 42l8-8m-10 4a6 6 0 1012 0 6 6 0 00-12 0z",
    stroke: "#94A3B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgNoImage;